import WebSocketService from "@/ws/WebSocketService";
import { AttendanceNotification } from "@/views/monitoring/socket.js";
import { DriverCommentNotification } from "@/views/rrhh/index.socket.js";


const RrhhSocket = (socket) => {

    const sections = JSON.parse(localStorage.getItem("sections"));
    if (!sections.find(sect => sect.module_id == 9)) return;
    const socketService = new WebSocketService(socket);
    socketService.subscribeChannel('rrhh-channel');

    // Events... 
    AttendanceNotification(socketService);
    DriverCommentNotification(socketService);
}

export default RrhhSocket;